import { MaybeRef } from '@vueuse/core'
import { computed, unref } from 'vue'

const formattedTime = (time: number, options = { format: 'h:mm', initTime: 'seconds' }) => {
  if (options.initTime === 'ms') {
    time = time / 1000 / 60
  }
  if (options.initTime === 'hours') {
    time = time * 60
  }
  let hours = String(Math.floor(time / 60))
  const minutes = String(Math.floor(time) % 60).padStart(2, '0')
  //   const seconds = String(Math.floor((time - Math.floor(time)) * 60)).padStart(2, '0')
  if (options.format === 'hh:mm') hours = hours.padStart(2, '0')
  return `${hours}:${minutes}`
}

type UseFormatTimeReturn = (
  initTime: MaybeRef<number>,
  options?: { format: 'hh:mm' | 'h:mm'; initTime: 'hours' | 'minutes' | 'ms' }
) => string

/**
 * Formats elapsed time as h:mm. For time as a date, see useFormatDate => time()
 * @param initTime number, defaults to minutes
 * @param options object, defaults format to 'h:mm' and the init time format as minutes.
 * @returns string as h:mm
 */
export const useFormatTime: UseFormatTimeReturn = (
  initTime: MaybeRef<number>,
  options = { format: 'h:mm', initTime: 'minutes' }
) => {
  return computed(() => {
    return formattedTime(unref(initTime), options)
  }).value
}
